// Shared BI page descriptors for the /routines surface, imported by the page (page-load BI), the list
// body and the detail modal (click BI) so the page_name stays in one place. The generic src:198
// `pageName` is a separate, cross-surface vocabulary and is resolved from the route — see
// `lib/bi-page-name.ts`.
export const ROUTINES_PAGE = { page_name: 'routines_page' as const };
export const ROUTINE_DETAILS_PAGE = { page_name: 'routine_details' as const };
